
    import './styles.scoped.css';
    export default {
  "visible-content": "awsui_visible-content_tc96w_lfh66_185",
  "visible-content-toggle": "awsui_visible-content-toggle_tc96w_lfh66_186",
  "visible-content-groups": "awsui_visible-content-groups_tc96w_lfh66_187",
  "visible-content-group": "awsui_visible-content-group_tc96w_lfh66_187",
  "visible-content-title": "awsui_visible-content-title_tc96w_lfh66_192",
  "visible-content-group-label": "awsui_visible-content-group-label_tc96w_lfh66_201",
  "visible-content-option": "awsui_visible-content-option_tc96w_lfh66_207",
  "visible-content-option-label": "awsui_visible-content-option-label_tc96w_lfh66_218",
  "content-display-option-toggle": "awsui_content-display-option-toggle_tc96w_lfh66_409",
  "content-display-option-content": "awsui_content-display-option-content_tc96w_lfh66_413",
  "content-display-option": "awsui_content-display-option_tc96w_lfh66_409",
  "placeholder": "awsui_placeholder_tc96w_lfh66_436",
  "sorting": "awsui_sorting_tc96w_lfh66_436",
  "content-display-option-label": "awsui_content-display-option-label_tc96w_lfh66_463",
  "drag-overlay": "awsui_drag-overlay_tc96w_lfh66_471",
  "content-display": "awsui_content-display_tc96w_lfh66_409",
  "content-display-title": "awsui_content-display-title_tc96w_lfh66_498",
  "content-display-description": "awsui_content-display-description_tc96w_lfh66_506",
  "content-display-option-list": "awsui_content-display-option-list_tc96w_lfh66_514",
  "root": "awsui_root_tc96w_lfh66_520",
  "modal-root": "awsui_modal-root_tc96w_lfh66_521",
  "trigger-button": "awsui_trigger-button_tc96w_lfh66_522",
  "cancel-button": "awsui_cancel-button_tc96w_lfh66_523",
  "confirm-button": "awsui_confirm-button_tc96w_lfh66_524",
  "custom": "awsui_custom_tc96w_lfh66_525",
  "second-column-small": "awsui_second-column-small_tc96w_lfh66_529",
  "wrap-lines": "awsui_wrap-lines_tc96w_lfh66_533",
  "striped-rows": "awsui_striped-rows_tc96w_lfh66_534",
  "content-density": "awsui_content-density_tc96w_lfh66_535",
  "page-size": "awsui_page-size_tc96w_lfh66_536",
  "page-size-form-field": "awsui_page-size-form-field_tc96w_lfh66_537",
  "page-size-radio-group": "awsui_page-size-radio-group_tc96w_lfh66_538",
  "sticky-columns": "awsui_sticky-columns_tc96w_lfh66_539",
  "sticky-columns-form-field": "awsui_sticky-columns-form-field_tc96w_lfh66_540",
  "sticky-columns-radio-group": "awsui_sticky-columns-radio-group_tc96w_lfh66_541",
  "sticky-columns-first": "awsui_sticky-columns-first_tc96w_lfh66_542",
  "sticky-columns-last": "awsui_sticky-columns-last_tc96w_lfh66_543"
};
  